module.exports = __webpack_public_path__ + "static/media/icon-letter.a8515012.svg";